import { setBehaviourEvent } from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

export const callToAction = (name) => {
    const category = 'open_configurator';
    const action = 'click';
    const label = name;

    setBehaviourEvent({ category, action, label });
    setFunnelyticsBehaviourEvent({ category, action, label });
}